<!-- MENU MOVIL PARA USUARIO NORMAL -->


<template>

  <div>
<OpenLinksTecDialog ref="componenteHijoOpenLinksTec"></OpenLinksTecDialog>

    

  <v-navigation-drawer
    v-model="drawer"
    app
    temporary
  >



    
    <v-flex xs12 class="pl-3 pt-5 grey lighten-5 pb-2">
      <v-img
            :src="require('@/assets/img/use/logoteczoav1.png')"
            :lazy-src="require('@/assets/img/use/logoteczoav1.png')"
            width="10vh">
            <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
            >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
      </v-img>
      <p class="google-font mt-2" style="font-size:130%">{{ChapterDetails.descripcion}}</p>
      
    </v-flex>
   


        <v-list-item>
          <v-list-item-avatar>
            <v-img src="@/assets/img/team/avatar.png"></v-img>
          </v-list-item-avatar>
  
          <v-list-item-content>
            <v-list-item-title>Menu Store</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
  
        <v-divider></v-divider>
  
         <v-list dense>
  
          <v-list-item
            v-for="(link, i) in linksStore"
            :key="i"
            :to="link.to"
          >
            <v-list-item-icon>
              <v-icon  @click="onClick($event, link)">{{ link.icon }}</v-icon>
            </v-list-item-icon>
  
            <v-list-item-content>
              <v-list-item-title >{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


        <!-- ITEM ESTATICO -->
  <v-list-item @click="openLinksTec()">

    <v-list-item-icon>
      <v-icon>mdi-link-plus</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>LINKS TEC</v-list-item-title>
    </v-list-item-content>

  </v-list-item> 
<!-- FIN ITEM ESTATICO -->



        </v-list>
  </v-navigation-drawer>

    </div>
</template>

<script>
import ChapterDetails from '@/assets/data/chapterDetails.json'


import OpenLinksTecDialog from "@/components/tienda/menu/OpenLinksTecDialog.vue"
  // Utilities
  import {
    mapGetters,
    mapMutations
  } from 'vuex'
  export default {
    name: 'MenuMovilStore',
    data() {
      return {
        ChapterDetails:ChapterDetails
      }
    },
    components:{
          OpenLinksTecDialog,

    },
    computed: {
      ...mapGetters(['linksStore']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.setDrawer(val)
        }
      }
    },
    methods: {

openLinksTec()
      {

         this.$refs.componenteHijoOpenLinksTec.openDialog();

      },


      ...mapMutations(['setDrawer']),
      onClick (e, item) {
        e.stopPropagation()
        if (item.to === '/') {
          this.$vuetify.goTo(0)
          this.setDrawer(false)
          return
        }
        if (item.to || !item.href) return
        this.$vuetify.goTo(item.href)
        this.setDrawer(false)
      }
    },
  perfilEdit(){

    var identificador = localStorage.getItem('identificador');


if (identificador) {
      // Navegar a la ruta con el identificador como parámetro
      this.$router.push(`/perfil/${identificador}/add/`);
    } else {
      console.error('No se encontró ningún identificador en el Local Storage.');
    }

  }
  }
</script>


